import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Loader2, ArrowUpRight } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { clientService } from '../../api';
import { DocItemRow } from './DocumentsPanel';
import { useDocActions } from './useDocActions';

export const TaskDocsPopover = ({ task, status, onChanged }) => {
  const [req, setReq] = useState(null);
  const load = () => clientService.documents(task.clientId).then((d) => setReq(d.requests[0] || null));
  const { busyItem, toggle, upload } = useDocActions((r) => { setReq(r); onChanged?.(); });
  const ok = status.received >= status.total;

  return (
    <Popover onOpenChange={(o) => { if (o) load(); }}>
      <PopoverTrigger asChild>
        <button type="button" className={`mt-1 inline-flex text-[10px] font-medium px-1.5 py-0.5 rounded hover:ring-1 transition-shadow ${ok ? 'bg-emerald-50 text-emerald-800 hover:ring-emerald-300' : 'bg-amber-50 text-amber-800 hover:ring-amber-300'}`} data-testid={`task-doc-status-${task.id}`}>
          {ok ? 'Docs received' : `Waiting on client · ${status.received}/${status.total} docs`}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-96 p-0" data-testid={`task-doc-popover-${task.id}`}>
        <div className="px-4 py-3 border-b border-stone-100">
          <div className="font-semibold text-sm text-stone-900">{task.clientName} · documents</div>
          <div className="text-xs text-stone-500">{req ? req.periodLabel : status.periodLabel} · tick items as they arrive</div>
        </div>
        {!req ? <div className="p-6 flex justify-center"><Loader2 size={16} className="animate-spin text-stone-400"/></div> : (
          <div className="divide-y divide-stone-100 max-h-80 overflow-y-auto">
            {req.items.map((it) => <DocItemRow key={it.id} compact item={it} busy={busyItem === it.id} onToggle={toggle(req)} onUpload={upload(req)}/>)}
          </div>
        )}
        <Link to={`/dashboard/clients/${task.clientId}?tab=documents`} className="flex items-center justify-center gap-1 px-4 py-2.5 border-t border-stone-100 text-xs font-medium text-emerald-800 hover:bg-emerald-50" data-testid={`task-doc-open-client-${task.id}`}>
          Edit checklist & reminders <ArrowUpRight size={12}/>
        </Link>
      </PopoverContent>
    </Popover>
  );
};
